import React, { useState, useEffect } from "react";
import { Box, Typography, Button, CircularProgress, TextField } from "@mui/material";
import TitleForm from "../../../common/components/titleform";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import colors from "../../../common/styles/colors";
import { useTranslation } from "react-i18next";
import SheAiSttService from "../../../services/sheai/SheAiSttService";
import { useSocket } from "../../../services/hooks/socketHook";
import secureLocalStorage from "react-secure-storage";

interface SttModuleProps {
  debriefingId: any;
  evaluatedId: any;
  styles: any;
  setLoader: (v: boolean) => void;
  video: string;
  videoId?: string;
  arrVideo?: any[];
  cameraMain?: boolean;
}

const SttModule: React.FC<SttModuleProps> = ({ debriefingId, evaluatedId, styles, setLoader, video, videoId, arrVideo, cameraMain }) => {
  const { t } = useTranslation();
  const [sttStatus, setSttStatus] = useState("");
  const [sttError, setSttError] = useState(false);
  const [sttMessage, setSttMessage] = useState("");
  const [sttProgress, setSttProgress] = useState(0);
  const [numSpeakers, setNumSpeakers] = useState(2);
  const [showResult, setShowResult] = useState(false);
  const [sttResult, setSttResult] = useState<any>(null);
  const [segmentFilter, setSegmentFilter] = useState("");

  // WebSocket modular para STT
  // useSocket({
  //   callBack: (payload) => {
  //     if (parseInt(payload.status) === 100) {
  //       setSttStatus("finished");
  //     }
  //     setSttProgress(parseInt(payload.status));
  //   },
  //   channel: 'status-stt',
  //   event: '.App\\Events\\EventProcessingSttStatus',
  // });

  const startSttModule = async () => {
    setLoader(true);
    setSttError(false);
    try {
      await SheAiSttService.start({
        evaluated_id: evaluatedId,
        debriefing_id: debriefingId,
        priority: 0,
      }).then(response => {
        setLoader(false);
        setSttStatus("created");
        setSttMessage("Enviado para fila de processamento");
        //console.log("STT Start Response:", response);
      });
    } catch (e) {
      setSttError(true);
      setLoader(false);
    }
  };

  const fetchSttStatus = async () => {
    setLoader(true);
    try {
      //console.log("Debriefing ID:", debriefingId);
      await SheAiSttService.result(debriefingId)
        .then(response => {
          //console.log("STT Result Result:", response.data);
          if (response && response.data) {
            setSttStatus(response.data.status || response.data.msg);
            setSttMessage(response.data.msg || "");
            setSttProgress(response.data.progress || 0);
            setSttResult(response.data.content[0].result || null);
            //console.log("STT Result Data:", response.data.content[0]);
            if (response.data.status === "in_progress") {
              setSttMessage(`Processando...`);
            }

            if (response.data.status === "finished") {
              setSttMessage("Processamento concluído.");
            }

            if (response.data.status === "failed") {
              setSttMessage("Contate o suporte ou tente novamente.");
            }
          }
      });
    } catch (e) {

      //console.error("Error fetching STT status:", e);
      setSttError(true);
    }
    setLoader(false);
  };

  useEffect(() => {

    fetchSttStatus();

  }, []);

  const isVideoAvailable = video !== null && video !== undefined && video !== "";

  return (
    <Box className={styles.box}>
      <TitleForm
        title={"Transcrição audio"}
        icon={
          <VolumeUpIcon
            sx={{ color: colors.purpleIcon, fontSize: 37, marginRight: 3 }}
          />
        }
      />
      <Box>
        <Typography className={styles.titleIa}>
          {t("first_title_dialog_description_data_ia")}
          &quot;{t("second_title_dialog_description_data_ia")}&quot;
          {t("third_title_dialog_description_data_ia")}
          &quot;{t("title_dialog_description_data_ia_view")}&quot;
          {t("fifth_title_dialog_description_data_ia")}
        </Typography>
      </Box>
      { (sttStatus === "not_found" || sttStatus === "failed") && (
        <Box sx={{ display: secureLocalStorage.getItem('role') == 5 ? 'none' : 'block' }}>
          <Button
            variant="outlined"
            onClick={startSttModule}
            disabled={!isVideoAvailable}

          >
            {t("btn_start_stt")}
          </Button>
          {/* Input numérico para número de speakers, aparece apenas se o botão está habilitado */}
          {isVideoAvailable && (
            <TextField
              type="number"
              label="Nº de Pessoas"
              value={numSpeakers}
              onChange={e => setNumSpeakers(Number(e.target.value))}
              inputProps={{ min: 1 }}
              size="small"
              sx={{  ml: 2, width: 120, display: 'none' }}
            />
          )}
          {/* {sttError && <Typography color="error">{t("title_description_error_sheai")}</Typography>} */}
        </Box>
      )}
      {/* Bloco de status STT e botão de resultado */}
      {sttStatus !== "finished" && (
        <Box sx={{ mt: 3, p: 2, background: '#f5f5f5', borderRadius: 2 }}>
          <Typography variant="body2" color="primary">
            STT Status: <strong>{sttStatus}</strong>
          </Typography>
          <Typography variant="body2" color="primary">
            STT Message: <strong>{sttMessage}</strong>
          </Typography>
        </Box>
      )}
      {sttStatus === "finished" && !showResult && (
        <Box sx={{ mt: 3 }}>
          <Button variant="contained" color="primary" onClick={() => setShowResult(true)}>
            Ver resultado
          </Button>
        </Box>
      )}
      {/* Bloco de resultado detalhado */}
      {sttStatus === "finished" && showResult && sttResult && (
        <Box sx={{ mt: 3, p: 2, background: '#f5f5f5', borderRadius: 2 }}>
          {/* Linha 1: Imagem mic_possession */}
          <Box sx={{ mb: 2, textAlign: 'left' }}>
            <Typography variant="h5" sx={{ mb: 1 }}>Posse do Microfone</Typography>
            <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
              Gráfico de quem mais falou durante a gravação.
            </Typography>
            {sttResult.mic_possession && (
              <img src={`data:image/png;base64,${sttResult.mic_possession}`} alt="Mic Possession" style={{ maxWidth: '100%' }} />
            )}
          </Box>
          {/* Linha 2: 2 colunas */}
          <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
            {/* Coluna 1: Transcrição */}
            <Box sx={{ flex: 1, minWidth: 200 }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Segmentos de Transcrição</Typography>
              <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                Trechos identificados por participante e tempo:
              </Typography>
              {/* Nova linha: Segmentos de transcrição */}
              {Array.isArray(sttResult.segments_trancriptions) && sttResult.segments_trancriptions.length > 0 && (
                <Box sx={{ mt: 2, background: '#fff', borderRadius: 1, p: 2, border: '1px solid #eee' }}>

                  {/* Campo de busca/filtro */}
                  <TextField
                    label="Buscar na transcrição"
                    variant="outlined"
                    size="small"
                    value={segmentFilter}
                    onChange={e => setSegmentFilter(e.target.value)}
                    sx={{ mb: 2, width: 300 }}
                  />
                  <Box sx={{ overflow: 'auto', fontFamily: 'monospace', fontSize: 14 }}>
                    {sttResult.segments_trancriptions
                      .filter((seg: any) =>
                        segmentFilter.trim() === "" ||
                        (seg.transcription && seg.transcription.toLowerCase().includes(segmentFilter.toLowerCase()))
                      )
                      .map((seg: any, idx: number) => (
                        <Box
                          key={idx}
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            bgcolor: idx % 2 === 0 ? '#f9f9f9' : '#e3e3e3',
                            borderRadius: 1,
                            p: 1,
                            mb: 1,
                            gap: 1
                          }}
                        >
                          {/* Speaker chip */}
                          <Box
                            sx={{
                              bgcolor: colors.purpleIcon,
                              color: '#fff',
                              px: 1.5,
                              py: 0.5,
                              borderRadius: 2,
                              fontWeight: 600,
                              fontSize: 13,
                              mr: 1,
                              minWidth: 80,
                              textAlign: 'center',
                              boxShadow: 1
                            }}
                          >
                            {seg.speaker}
                          </Box>
                          {/* Badge de tempo */}
                          <Box
                            sx={{
                              bgcolor: '#1976d2',
                              color: '#fff',
                              px: 1,
                              py: 0.2,
                              borderRadius: 1,
                              fontSize: 12,
                              fontWeight: 500,
                              mr: 1,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5
                            }}
                          >
                            <span role="img" aria-label="clock">⏱️</span> {seg.start.toFixed(2)} - {seg.end.toFixed(2)}
                          </Box>
                          {/* Transcrição */}
                          <Typography variant="body2" sx={{ flex: 1 }}>
                            {seg.transcription}
                          </Typography>
                        </Box>
                      ))}
                  </Box>
                </Box>
              )}
            </Box>
            {/* Coluna 2: Imagem speech_possession */}
            <Box sx={{ flex: 1, minWidth: 200, textAlign: 'left' }}>
              <Typography variant="h6" sx={{ mb: 1 }}>Posse da Fala</Typography>
              <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                Gráfico de distribuição da fala entre os participantes.
              </Typography>
              {sttResult.speech_possession && (
                <img src={`data:image/png;base64,${sttResult.speech_possession}`} alt="Speech Possession" style={{ maxWidth: '100%' }} />
              )}
            </Box>
          </Box>
          {/* Linha 3: Imagem wordcloud */}
          <Box sx={{ textAlign: 'left', mb: 2 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Nuvem de Palavras</Typography>
            <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
              Palavras mais frequentes na transcrição.
            </Typography>
            {sttResult.wordcloud && (
              <img src={`data:image/png;base64,${sttResult.wordcloud}`} alt="Wordcloud" style={{ maxWidth: '100%' }} />
            )}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SttModule;
